module.exports = __webpack_public_path__ + "static/media/purple-10.ec41f96a.png";